import { useCallback, useContext, useEffect, useState } from 'react'
import Authorization from '../authorization/authorization'
import { AuthContext } from '../../context/auth.context'
import Modal from '../modal/modal'
import ConfirmModal from '../modals/confirmModal/confirmModal'
import userStore from '../../store/users'
import { observer } from 'mobx-react-lite'
import useStorage from '../../hooks/storage.hook'
import OutsideAlerter from '../outsideAlerter/outsideAlerter'
import DefaultModal from '../modals/defaultModal/defaultModal'

const User = ({ username, name, active = false }) => {
  return (
    <>
      <div
        className={`${!active ? 'hover:bg-Dominant/Dop hover:cursor-pointer' : ''} group p-[1.2rem] ease-in-out duration-300 bg-[#fff] `}>
        <span className='w-[2.4rem] h-[2.4rem]'></span>
        <div className='flex flex-col'>
          <span className='text-Regular(16_18) text-Content/Dark mb-[2px]'>{username}</span>
          <div className='flex justify-between text-Regular(12_14) gap-[4rem]'>
            <span className={`${active ? 'text-Accent/Dark_Yellow' : ''}`}>{name}</span>
            <span className=' block rounded-[8px] border border-Accent/Green text-Regular(10_12) text-Accent/Green px-[0.6rem]'>
              Выбрать
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

function UsersPanel() {
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [isModalLogoutOpened, setIsModalLogoutOpened] = useState(false)
  const { authState, login, logout } = useContext(AuthContext)
  const { getData } = useStorage()
  const { username, role } = userStore.currentUser
  const [candidates, setCandidates] = useState([])
  const [isOtherShowed, setIsOtherShowed] = useState(false)

  const closeOther = useCallback(() => {
    setIsOtherShowed(false)
  }, [])

  useEffect(() => {
    const users = getData('users')
    const current = users.find(x => x.active)
    userStore.setCurrentUser(current)
    const readyUsers = users.filter(x => !x.active)
    setCandidates(readyUsers)
  }, [authState.accessToken, getData])

  const onLoginHandler = props => {
    login(props)
    setIsOtherShowed(false)
  }

  const onLogoutHandler = () => {
    setIsModalLogoutOpened(false)
    logout()
  }

  return (
    <div onClick={ev => ev.stopPropagation()}>
      <OutsideAlerter onEvent={closeOther}>
        <div className=' relative hover:cursor-pointer'>
          <div
            onClick={() => setIsOtherShowed(!isOtherShowed)}
            className='border border-Content/Border p-[10px] flex gap-[12px flex items-center gap-[12px]'>
            <i className='icon-user text-Regular(24_30) flex items-center justify-center text-Accent/Blue relative after:w-[1.2rem] after:right-0 after:bottom-0  after:absolute after:h-[1.2rem] after:rounded-[50%] after:bg-Accent/Dark_Yellow'></i>
            <span className='text-Regular(16_18) '>{username}</span>
            <i
              className={`
						${isOtherShowed ? 'rotate-180 text-Accent/Blue' : 'text-Content/Middle'}
						 icon-arrow text-Regular(12_14) duration-300 ease-in-out m-auto  flex items-center justify-center`}></i>
            {/* <User
							username={username}
							name={role?.length && role[0].name}
							active={true}
						></User> */}
          </div>
          <div
            className={`${isOtherShowed ? 'opacity-100 translate-y-0 duration-300 ease-in-out visible  z-[120]' : 'opacity-0 translate-y-[10%] invisible  z-20'} min-w-[300px]  absolute  top-[100%] shadow-default right-0 bg-white border border-Content/Border border-t-0`}>
            <div className='max-h-[30rem] overflow-auto'>
              {candidates.map(({ accessToken, username, role, id }) => (
                <div
                  key={accessToken}
                  onClick={() =>
                    onLoginHandler({
                      accessToken,
                      id,
                      username,
                      role
                    })
                  }>
                  <User username={username} name={role?.length && role[0].name}></User>
                </div>
              ))}
            </div>
            <div className='p-[1.2rem] hover:cursor-pointer'>
              <span className='w-[2.4rem]h - [2.4rem]'></span>
              <span onClick={() => setIsModalOpened(true)} className='text-Regular(16_18) text-Accent/Blue'>
                Добавить нового пользователя
              </span>
            </div>
          </div>
          <Modal isOpen={!!isModalOpened} closeModal={() => setIsModalOpened(false)}>
            <Authorization afterLogin={() => setIsModalOpened(false)}></Authorization>
          </Modal>
        </div>
      </OutsideAlerter>
      <Modal isOpen={!!isModalLogoutOpened} closeModal={() => setIsModalLogoutOpened(false)}>
        <ConfirmModal
          title='Вы уверены, что хотите выйти из профиля?'
          onResolve={onLogoutHandler}
          onReject={() => setIsModalLogoutOpened(false)}></ConfirmModal>
      </Modal>
    </div>
  )
}

export default observer(UsersPanel)
